import React from 'react';
import { Link } from 'react-router-dom';
import { TargetIcon, TreesIcon, ChevronRightIcon } from 'lucide-react';
export function SportingClaysArchery() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2966">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2967">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2968">
          <div className="bg-white rounded-xl p-6 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2969">
            <div className="flex items-center gap-3 mb-4" data-id="element-2970">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
              backgroundColor: 'rgba(30,61,47,0.08)'
            }} data-id="element-2971">
                <TargetIcon size={20} style={{
                color: '#1e3d2f'
              }} data-id="element-2972" />
              </div>
              <h3 className="text-lg font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-2973">
                Sporting Clays
              </h3>
            </div>
            <p className="text-sm text-gray-700 mb-3" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2974">
              Sporting Clays has its own specific rules and schedule. Please
              visit the Sporting Clays page for complete details.
            </p>
            <Link to="/sporting-clays" className="inline-flex items-center gap-1 text-sm font-semibold hover:underline" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2975">
              View Sporting Clays Info
              <ChevronRightIcon size={14} data-id="element-2976" />
            </Link>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2977">
            <div className="flex items-center gap-3 mb-4" data-id="element-2978">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
              backgroundColor: 'rgba(30,61,47,0.08)'
            }} data-id="element-2979">
                <TreesIcon size={20} style={{
                color: '#1e3d2f'
              }} data-id="element-2980" />
              </div>
              <h3 className="text-lg font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-2981">
                Archery Range
              </h3>
            </div>
            <p className="text-sm text-gray-700 mb-3" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2982">
              The archery range is open dawn to dusk. Please visit the 3-D
              Archery page for specific rules and event information.
            </p>
            <Link to="/archery" className="inline-flex items-center gap-1 text-sm font-semibold hover:underline" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2983">
              View Archery Info
              <ChevronRightIcon size={14} data-id="element-2984" />
            </Link>
          </div>
        </div>
      </div>
    </div>;
}